import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AssessorAssignments, AssessorAssignmentsDto, AssessorAssignmentsValueDto, LookupOption, LookupOptionDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getAssignments(userId: string): Observable<AssessorAssignments> {
        return this.httpClient.get<AssessorAssignmentsDto>(`assessors/${userId}/assignments`).pipe(map((response) => new AssessorAssignments(response)));
    }

    updateAssignments(userId: string, dto: AssessorAssignmentsValueDto): Observable<AssessorAssignments> {
        return this.httpClient.put<AssessorAssignmentsDto>(`assessors/${userId}/assignments`, dto).pipe(map((response) => new AssessorAssignments(response)));
    }

    lookupSchools(organisationIds: string[]): Observable<LookupOption[]> {
        return this.lookup('schools/lookup', 'organisationId[]', organisationIds);
    }

    lookupCourses(schoolIds: string[]): Observable<LookupOption[]> {
        return this.lookup('courses/lookup', 'schoolId[]', schoolIds);
    }

    lookupPackages(schoolIds: string[]): Observable<LookupOption[]> {
        return this.lookup('packages/lookup', 'schoolId[]', schoolIds);
    }

    private lookup(endpoint: string, filterName: string, ids: string[]): Observable<LookupOption[]> {
        const params = ids.reduce((acc, id) => acc.append(filterName, id), new HttpParams());

        return this.httpClient.get<LookupOptionDto[]>(endpoint, { params }).pipe(map((response) => response.map((dto) => new LookupOption(dto))));
    }
}
